import axios from 'axios';

const baseURL = `${process.env.VUE_APP_BASE_URL}/api`;

const http = axios.create({
  baseURL,
});

http.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
}), (error) => Promise.reject(error));

export default http;
